// extracted by mini-css-extract-plugin
export default {"card":"f4w98","selected":"ZMNRN","disabled":"faAAe","price":"bqoIx","container":"PcYKX","wrapperImage":"J1T7x","imageWrapper":"ef8Fa","image":"srVg2","content":"sNXsI"};